/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Done_BodyInputs */



/**
* | output |
* | --- |
* | "Below is Wundo’s feedback. You can close this window when you are done reading." |
*
* @param {Practice_Session_Done_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_done_body = /** @type {((inputs?: Practice_Session_Done_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Done_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hieronder lees je de feedback van Wundo. Je kan dit venster sluiten als je klaar bent.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ci-dessous, le feedback de Wundo. Vous pouvez fermer cette fenêtre quand vous avez fini de lire.")
	return /** @type {LocalizedString} */ ("Below is Wundo’s feedback. You can close this window when you are done reading.")
});